export const authInitialState = {
  username: '',
  token: '',
};
